import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { SharedModule } from '../../shared.module';
import { DocumentPreviewComponent } from './document-preview.component';
import { PreviewModalComponent } from './components/preview-modal/preview-modal.component';
import { PdfViewerComponent } from './components/pdf-viewer/pdf-viewer.component';
import { SharedLibraryModule } from 'library-explorer';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';


@NgModule({
  declarations: [
    PreviewModalComponent,
    DocumentPreviewComponent,
    PdfViewerComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    NgxDocViewerModule,
    NgxExtendedPdfViewerModule,
    SharedLibraryModule
  ],
  exports: [
    PreviewModalComponent,
    DocumentPreviewComponent,
    PdfViewerComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DocumentPreviewModule { }
